

























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-drawer-content-wrapper',
  components: {},
})
export default class DrawerContentWrapper extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: String, default: '' }) readonly componentId: string;
  @Prop({ type: String, default: '' }) readonly bodyClass: string;

  // DATA
  // LIFECYCLE
  // created() { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
  // COMPUTED
  // METHODS
  // WATCHERS
}
